var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllCategories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00008 7.7798C2.00008 4.58762 4.5603 1.99985 7.7185 1.99985C9.23512 1.99985 10.6896 2.6088 11.762 3.69276C12.8345 4.77671 13.4369 6.24686 13.4369 7.7798C13.4369 9.36317 12.807 10.7978 11.7867 11.8418C11.7925 11.8471 11.7983 11.8527 11.804 11.8583L13.5071 13.2331H13.5367C13.8812 13.5813 13.8812 14.146 13.5367 14.4942C13.1921 14.8425 12.6334 14.8425 12.2889 14.4942L10.8755 12.8744C10.8206 12.8191 10.7756 12.7557 10.7416 12.6869C9.86458 13.2401 8.82847 13.5597 7.7185 13.5597C4.5603 13.5597 2.00008 10.972 2.00008 7.7798Z",
    fill: "#25245B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategories);
export default __webpack_public_path__ + "static/media/all-categories.527d1a0443d73cf30592559be0fd0044.svg";
export { ForwardRef as ReactComponent };